import { useState } from "react";
import BoldBlue from "./BoldBlue";
import { useTranslation } from "react-i18next";

const Text10LinesMax = (props) => {

    const [showMore, setShowMore] = useState(false);
    const { i18n } = useTranslation('common');

    if(!props.children) return (<></>);
    
    const maxChars = 800
    const textIsOver = props.children.length > maxChars;

    return ( <>
        <p style={{whiteSpace:"pre-wrap",fontSize:"20px"}}>{showMore || !textIsOver ? 
            props.children
        :
            props.children.slice(0,maxChars) + "..."
        }</p><br/>
        {textIsOver && !showMore && <BoldBlue style={{cursor:'pointer'}} onClick={() => setShowMore(true)}><img src='/img/fleche_bleue.png' alt=''/>{i18n.language === "fr" ? "LIRE PLUS" : "READ MORE"}</BoldBlue>}
    </>)
}

export default Text10LinesMax;